//React doesn't support importing SVG files, but it supports inline SVGs
//Use this tool to convert svg to JSX: https://svgr.now.sh/
import React from 'react'

const WebsiteSVG = props => (
  <svg
    width={123}
    height={101}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>Group 26</title>
    <defs>
      <path id="a" d="M0 .455h123V101H0z"/>
      <path id="c" d="M0 .462h123V26.32H0z"/>
      <path id="e" d="M0 102h123V1H0z"/>
    </defs>
    <g fill="none" fillRule="evenodd" opacity={0.3}>
      <mask id="b" fill="#fff">
        <use xlinkHref="#a"/>
      </mask>
      <path
        d="M7.517 4.55A3.418 3.418 0 0 0 4.1 7.961v85.53a3.418 3.418 0 0 0 3.417 3.413h107.966a3.418 3.418 0 0 0 3.417-3.412V7.962a3.418 3.418 0 0 0-3.417-3.413H7.517zM115.483 101H7.517C3.372 101 0 97.633 0 93.493V7.962C0 3.822 3.372.455 7.517.455h107.966c4.145 0 7.517 3.368 7.517 7.507v85.53c0 4.14-3.372 7.508-7.517 7.508z"
        fill="#B2B2B2"
        mask="url(#b)"
      />
      <path
        d="M120.95 24.244H2.05V8.076c0-3.058 2.448-5.538 5.467-5.538h107.966c3.02 0 5.467 2.48 5.467 5.538v16.168z"
        fill="#B2B2B2"
      />
      <mask id="d" fill="#fff">
        <use xlinkHref="#c"/>
      </mask>
      <path
        d="M4.1 22.167h114.8V8.077c0-1.909-1.533-3.462-3.417-3.462H7.517C5.633 4.615 4.1 6.168 4.1 8.076v14.091zM123 26.321H0V8.076C0 3.878 3.372.461 7.517.461h107.966c4.145 0 7.517 3.417 7.517 7.615v18.245z"
        fill="#B2B2B2"
        mask="url(#d)"
      />
      <path
        d="M108.957 15H41.043C39.919 15 39 14.1 39 13s.92-2 2.043-2h67.914c1.124 0 2.043.9 2.043 2s-.92 2-2.043 2"
        fill="#FFF"
      />
      <path d="M32 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0" fill="#FFD900"/>
      <path d="M24 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0" fill="#36E400"/>
      <path d="M15 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0" fill="#008CFF"/>
      <mask id="f" fill="#fff">
        <use xlinkHref="#e"/>
      </mask>
      <path fill="#B2B2B2" mask="url(#f)" d="M2 26h119v-4H2z"/>
    </g>
  </svg>
)

export default WebsiteSVG;
